<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
	<div class="flex flex-col gap-3">
		@if (isAzureEnabled || isMsaEnabled || isGoogleEnabled) {
			@if (isAzureEnabled) {
				<p-button
					pRipple
					type="button"
					fluid
					size="small"
					severity="secondary"
					icon="pi pi-microsoft"
					[label]="'Sign In With ' + AUTH_PROVIDER_LABELS[AuthProvider.AZURE]"
					(onClick)="signInWithProvider(AuthProvider.AZURE)"
				/>
			}
			@if (isMsaEnabled) {
				<p-button
					pRipple
					type="button"
					fluid
					size="small"
					severity="secondary"
					icon="pi pi-microsoft"
					[label]="'Sign In With ' + AUTH_PROVIDER_LABELS[AuthProvider.MSA]"
					(onClick)="signInWithProvider(AuthProvider.MSA)"
				/>
			}
			@if (isGoogleEnabled) {
				<p-button
					pRipple
					type="button"
					fluid
					size="small"
					severity="secondary"
					icon="pi pi-google"
					[label]="'Sign In With ' + AUTH_PROVIDER_LABELS[AuthProvider.GOOGLE]"
					(onClick)="signInWithProvider(AuthProvider.GOOGLE)"
				/>
			}
		}

		@if (showLocalSignIn()) {
			<input
				formControlName="username"
				id="username"
				type="text"
				autocomplete="off"
				placeholder="Username"
				pInputText
				pSize="small"
				fluid
				appToLowercase
				[ngClass]="(loginForm | isFieldInvalid: 'username') ? ['ng-invalid', 'ng-dirty'] : []"
				[tooltipStyleClass]="'p-tooltip-error'"
				[pTooltip]="(loginForm | isFieldInvalid: 'username') ? 'Valid username is required' : ''"
			/>
			<p-password
				formControlName="password"
				id="password"
				autocomplete="false"
				placeholder="Password"
				size="small"
				fluid
				[feedback]="false"
				[toggleMask]="true"
				[ngClass]="(loginForm | isFieldInvalid: 'password') ? ['ng-invalid', 'ng-dirty'] : []"
				[tooltipStyleClass]="'p-tooltip-error'"
				[pTooltip]="(loginForm | isFieldInvalid: 'password') ? 'Valid password is required' : ''"
			/>
			<p-button
				pRipple
				type="submit"
				fluid
				size="small"
				icon="pi pi-sign-in"
				label="Sign In"
				[loading]="isLoading()"
				[disabled]="!loginForm.valid"
			/>
		} @else {
			<p-button
				pRipple
				type="button"
				fluid
				size="small"
				severity="secondary"
				icon="pi pi-user"
				[label]="AUTH_SIGN_IN_LOCAL_LABEL"
				(onClick)="onShowLocalSignIn()"
			/>
		}
	</div>
</form>
